

import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Card, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import './campaigncss/Instructor.css';
import axios from "axios";
import useTranslations from '../transalation/TranslationUtils';
import { initCampaignSimpleData, initialCampaignBasicInfo, setCampaignSimpleData, setCampaignSimpleDataToCampaignData, updateCampaign } from "app/redux/slices/rdxCampaignSlice";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { DEFAULT_IP } from "app/utils/constant";

function Instructor() {
    const { save, instructor2, showErrMsg, showSuccessMsg, none, fieldIsRequired, mName } = useTranslations();

    const dispatch = useDispatch();
    const campaignDetails = useSelector((state) => state.rdxCampaign?.campaignEditData || {});
    const editBasic = useSelector((state) => state.rdxCampaign?.editBasic || initialCampaignBasicInfo);

    const [availableInstructors, setAvailableInstructors] = useState([]);

    useEffect(() => {
        fetchInstructorList();
        let data = {
            data: { ...campaignDetails },
            projection: "editBasic",
            type: "obj"
        };
        dispatch(initCampaignSimpleData(data));
    }, []);

    const fetchInstructorList = async () => {
        const getRes = await axios.get(DEFAULT_IP + "/webapp/memportal/getinstrcutorlist");

        let data = getRes.data;

        if (1 == data?.code) {
            // data.data.unshift({
            //     "account_id": "",
            //     "account_name": none()
            // });
            setAvailableInstructors(data.data);
        } else {
            alert(showErrMsg(data));
        }
    };


    const handleSaveInstructor = async () => {
        if (!editBasic.campaign_tutor) {
            alert(fieldIsRequired());
            return;
        }

        let sendData = {
            campaign_id: campaignDetails.campaign_id,
            campaign_tutor: editBasic.campaign_tutor
        }
        const postRes = await axios.post(DEFAULT_IP + "/webapp/memportal/updateinstructor", sendData);

        let data = postRes.data;

        if (1 == data?.code) {
            let rData = {
                data: editBasic,
                projection: "self",
                base: campaignDetails
            };
            dispatch(setCampaignSimpleDataToCampaignData(rData));
            alert(showSuccessMsg(data));
        } else {
            alert(showErrMsg(data));
        }
    };

    return (
        <Container fluid>
            <Row>
                <Card className="mt-0 border-0" style={{ position: "relative" }}>
                    <Card.Body>
                        <Form>
                            <Row className="align-items-center mb-3">
                                <Col md={6} className="d-flex align-items-center">
                                    <h5 className="basicheading">{instructor2()}</h5>
                                </Col>
                                <Col md={6} className="text-end">
                                    {/* <Button variant="secondary" className="basiccancelbtnn me-2">{cancel()}</Button> */}
                                    <Button variant="primary" className="basicsavebtn me-3" onClick={handleSaveInstructor}>{save()}</Button>
                                </Col>
                            </Row>

                            <Row className="mt-3">
                                <Col md={4}>
                                    <Form.Group controlId={`inquiry-1`} className="floating-label-group">
                                        <Form.Select
                                            name="inquiry"
                                            className="floating-input"
                                            value={editBasic.campaign_tutor}
                                            onChange={(e) => {
                                                const { value } = e.target;
                                                let data = {
                                                    data: value,
                                                    projection: "editBasic",
                                                    path: "editBasic.campaign_tutor"
                                                }
                                                dispatch(setCampaignSimpleData(data));
                                            }}>
                                            <option value={""}></option>
                                            {availableInstructors.map((instructor, index) => (
                                                <option key={index} value={instructor.account_id}>
                                                    {instructor.account_name}
                                                </option>
                                            ))}

                                        </Form.Select>
                                        <Form.Label className="floating-label">{mName()}</Form.Label>
                                    </Form.Group>
                                </Col>

                                <Col md={1} className="d-flex justify-content-center align-items-center">
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
            </Row>
        </Container>
    );
}

export default Instructor;











